class SlideListeners {
    /**
     *
     * @param {HTMLElement[]|NodeListOf} slides
     * @param {Number} index
     */
    constructor(slides, index = 1) {
        if (index === 0) {
            index = 1;
        }

        this.index                  = index;
        this.slides                 = slides;
        this.slide                  = this.slides[this.index];
        this.inputContainers        = this.slide.querySelectorAll('.input-container');
        this.contentTypeToFilterUrl = this.inputContainers[0].getAttribute('data-content-type-to-filter-url');
        this.nextSlideNumber        = parseInt(this.inputContainers[0].getAttribute('data-next-slide'));
        this.nextButton             = this.slide.querySelector(".next");
        this.nextSlide              = this.slides[this.nextSlideNumber];
        this.nextSlideDivResult     = this.nextSlide.querySelector('.dynamic-container-content');
        this.previousButtonTop      = this.slide.querySelector(".back");
        this.previousButtonBottom   = this.slide.querySelector('.container-btn-choose-my-cable').querySelector('.back');
        this.navbarStart            = document.querySelector('.navbar-start');
        this.navbarBrand            = document.querySelector('.navbar-brand');
        this.loaderContainer        = document.querySelector('.loader-container');
        this.firstSlideListener     = null;
        this.header                 = document.getElementById('header');
        this.mySwiperVertical       = document.querySelector('main > .swiper-container').swiper;
        this.browserOn = null;

        const RADIOS = this.slide.querySelectorAll('input[type=radio]');

        for (let i = 0; i < RADIOS.length; i++) {
            const RADIO = RADIOS[i];
            if (RADIO.checked) {
                if(RADIO.parentElement.getAttribute('data-content-type-to-filter-url') === null){
                    let parentRadio = RADIO.parentElement.parentElement;
                    this.initNextSlide(parentRadio);
                }else{
                    let parentRadio = RADIO.parentElement;
                    this.initNextSlide(parentRadio);
                }
                break;
            }
        }

        this._getBrowser();
        this._initNavigationListener();
        this._initForm();
    }

    // to know the browser we are on
    _getBrowser() {
        navigator.sayswho= (function(){
            let ua= navigator.userAgent, tem,
                M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if(/trident/i.test(M[1])){
                tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
                return 'IE '+(tem[1] || '');
            }
            if(M[1]=== 'Chrome'){
                tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
                if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
            }
            M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
            if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
            return M.join(' ');
        })();

        this.browserOn = navigator.sayswho.split(" ")[0];
    }

    _initNavigationListener() {
        // this.homeButtons[0].addEventListener("click", this._homeButtonsClick.bind(this));

        const NEXT_CLONE           = this.nextButton.cloneNode(true);
        const NEXT_PREVIOUS_TOP    = this.previousButtonTop.cloneNode(true);
        const NEXT_PREVIOUS_BOTTOM = this.previousButtonBottom.cloneNode(true);

        this.nextButton.parentNode.replaceChild(NEXT_CLONE, this.nextButton);
        this.previousButtonTop.parentNode.replaceChild(NEXT_PREVIOUS_TOP, this.previousButtonTop);
        this.previousButtonBottom.parentNode.replaceChild(NEXT_PREVIOUS_BOTTOM, this.previousButtonBottom);

        this.nextButton           = NEXT_CLONE;
        this.previousButtonTop    = NEXT_PREVIOUS_TOP;
        this.previousButtonBottom = NEXT_PREVIOUS_BOTTOM;

        this.nextButton.addEventListener("click", this._nextButtonClick.bind(this));
        this.previousButtonTop.addEventListener("click", this._previousBtnTopClick.bind(this));
        this.previousButtonBottom.addEventListener("click", this._previousBtnBottomClick.bind(this));
    }

    _homeButtonsClick(e) {
        e.preventDefault();
        document.body.classList.add("slider-is-active");
        this.slide.classList.add("active");
        this.slides[1].classList.add("active");
        this.firstSlideListener = new SlideListeners(document.getElementById("choose-a-cable-section").querySelectorAll('.main-content'));

        // Removes all the reset classes
        for (let i = 0; i < this.slides.length; i++) {
            if (this.slides[i].classList.contains("reset")) {
                this.slides[i].classList.remove("reset");
            }
        }
    };

    _nextButtonClick() {
        // Check if we are allowed to navigate to the next slide because the form contains no error
        /* && j <= this.sliderItems.length - 3*/
        if (this._isFormValid()) {
            const VALUE = this.slide.querySelector('input:checked').value;
            console.log(VALUE);
            const HTTP  = new Http;

            // If we are at the end of the form (next step is the form results), we will submit form data
            if (this.contentTypeToFilterUrl === "form-results") {
                HTTP.ajax({url: this.contentTypeToFilterUrl, type: 'POST', formData: new FormData(document.getElementById('buildings-form')), json: false})
                    .then(response => {
                        // Move to next slide
                        this._updateContentAndMoveToNextSlide(response);

                        // this is handling the slide animation while pressing the back bottom btn on the results slide
                        let btnBackBottomResults = document.getElementById('back-btn-results');
                        let slideResults         = document.querySelector('.slide6');
                        btnBackBottomResults.addEventListener('click', () => {
                            slideResults.classList.remove('active');
                            this.slides[this.index].classList.remove('inactive');
                            this.slides[this.index].classList.add('active');
                        });
                        new MakeBreadcrumb();
                    });
            }
            // Otherwise handle next slide content loading
            else {
                this.loaderContainer.classList.add('active');
                // get the time before the request
                let ajaxTime = new Date().getTime();
                HTTP.get(this.contentTypeToFilterUrl.replace('{ID}', VALUE), null, false)
                    .then(response => {
                        // Remove initial listener on the next button in case we go back and perform a new form flow
                        const NEW_NEXT_BUTTON = this.nextButton.cloneNode(true);
                        this.nextButton.parentNode.replaceChild(NEW_NEXT_BUTTON, this.nextButton);

                        // Move to next slide
                        this._updateContentAndMoveToNextSlide(response);

                        //new MakeBreadcrumb(this.index);

                        // get the src of the image building that the user selected and replace the image src of the nextSlide by the first one
                        if (this.nextSlide.classList.contains('slide2')) {
                            this.buildingTypeImg     = this.nextSlide.querySelector('#building-type-img');
                            this.buildingTypeImg.src = this.imgContainer[VALUE - 1].querySelector("img").src;
                        }

                        // get the time after the request minus the time before the request
                        let requestTime = new Date().getTime() - ajaxTime;

                        setTimeout(() => {
                            this.nextSlide.querySelector('.container').classList.add('active');
                            this.loaderContainer.classList.remove('active');
                        }, requestTime);

                        // Add listeners to the next slide
                        new SlideListeners(this.slides, this.nextSlideNumber);
                        new MakeBreadcrumb();

                    });
            }
        }
    }

    _updateContentAndMoveToNextSlide(response) {
        // Update result div
        this.nextSlideDivResult.innerHTML = response;

        // Move to next slide
        this.slide.classList.add("inactive");
        this.nextSlide.classList.add("active");
        this.slide.classList.remove("active");
    }

    _previousBtnTopClick() {

        // to not send two ajax requests or more when the user wants to go back and change his choices
        delete this.contentTypeToFilterUrl;

        // close the open menu if it is open
        this.navbarStart.classList.remove('is-clicked-while-slider-is-active');

        // allow the user to scroll between each sections
        this.mySwiperVertical.allowSlideNext = true;
        this.mySwiperVertical.allowSlidePrev = true;

        // prevent the user to scroll through the current section
        this.mySwiperVertical.mousewheel.enable();
        this.mySwiperVertical.attachEvents();

        // remove the background header
        this.header.classList.add('slide-out');
        setTimeout(() => {
            this.header.classList.remove('slide-out');
            this.header.classList.remove('set-bg');
        }, 500);

        // allow the user to scroll vertically again
        this.mySwiperVertical.mousewheel.enable();

        for (let i = 0; i < this.slides.length; i++) {
            this.slides[i].classList.remove("active");
            this.slides[i].classList.remove("inactive");
            this.slides[i].classList.add("reset");
            document.body.classList.remove("slider-is-active");

            // remove the green color item menu after the 400ms animation
            SlideListeners._removeColorActiveItemMenu(this.navbarStart, this.navbarBrand);

            delete this.firstSlideListener;
        }

        // to  not see the previous slides during the animation after clicking on the back button
        SlideListeners._hidePreviousSlidesDuringTheBackAnimation(this.index, this.slides);
    }

    _previousBtnBottomClick() {
        // to not send two ajax requests or more when the user wants to go back and change his choices
        delete this.contentTypeToFilterUrl;

        // on the first slide (buildings type)
        if (this.index === 1) {
            this.slides[0].classList.remove("active");
            this.slide.classList.remove("active");
        }
        // the others
        else {
            // if the previous slide is empty, move to the previous previous slide
            if (!this.slides[this.index - 1].classList.contains('inactive')) {
                // ERT CASE
                if (this.slides[1].classList.contains('inactive') && !this.slides[2].classList.contains('inactive') && !this.slides[3].classList.contains('inactive')) {
                    this.slides[1].classList.remove('inactive');
                    this.slides[1].classList.add('active');
                    this.index -= 3;
                } else {
                    this.slides[this.index - 2].classList.add('active');
                    this.slides[this.index - 2].classList.remove('inactive');
                    this.index -= 2;
                }
            } else {
                this.slides[this.index - 1].classList.remove("inactive");
                this.slides[this.index - 1].classList.add("active");
                this.index--;
            }
            this.slide.classList.remove("active");
            new SlideListeners(this.slides, this.index);
            new MakeBreadcrumb(true);
        }
    }

    _isFormValid() {
        const IS_FIRST_SLIDE     = this.slide.classList.contains('slide1');
        const ERROR_FORM         = this.slide.querySelector(".error-form");
        let hasAtLeastOneChecked = false;

        // Check if user made any choice from the input list
        for (let i = 0; i < this.inputContainers.length; i++) {
            if (this.inputContainers[i].querySelector('input').checked === true) {
                if (IS_FIRST_SLIDE) {
                    this.imgContainer = this.slide.getElementsByClassName('img-container');
                }
                // As soon as a radio button got clicked on, we escape from the loop
                // and set a var to true
                hasAtLeastOneChecked = true;
                break;
            }
        }

        // Display error message if needed
        if (!hasAtLeastOneChecked) {
            ERROR_FORM.classList.add("active");

            return false;
        }

        return true;
    }

    _formInputClick(e) {
        e.preventDefault();

        const CONTAINER   = e.currentTarget;
        const INPUT_RADIO = CONTAINER.querySelector('input[type=radio]');
        const CURRENT_SLIDE_HEIGHT = this.slide.scrollHeight;

        if (CONTAINER.hasAttribute('data-title-breadcrumb')) {
            this.initNextSlide(CONTAINER);
        }
        // Handle input radio selection
        SlideListeners._handleRadioSelection(CONTAINER, INPUT_RADIO, this.slide);

        if(this.browserOn !== "IE"){
            this.slide.scrollBy({
                top: CURRENT_SLIDE_HEIGHT,
                behavior: "smooth"
            });
        }else{
            this.slide.scrollTop = CURRENT_SLIDE_HEIGHT;
        }
    }

    _initForm() {
        // Handle ajax call for next slide
        for (let i = 0; i < this.inputContainers.length; i++) {
            this.inputContainers[i].addEventListener('click', this._formInputClick.bind(this), false);
        }
    }

    initNextSlide(container) {
        this.contentTypeToFilterUrl = container.getAttribute('data-content-type-to-filter-url');
        this.nextSlideNumber        = parseInt(container.getAttribute('data-next-slide'));
        this.nextSlide              = this.slides[this.nextSlideNumber];
        if (this.nextSlide) {
            this.nextSlideDivResult = this.nextSlide.querySelector('.dynamic-container-content');
        }
    }

    static _handleRadioSelection(container, inputRadio, currentSlide, nextBtn) {
        // Removes the error if a radio button got clicked on
        if (currentSlide.classList.contains('slide3')) {
            container.parentElement.parentElement.parentElement.querySelector('.error-form').classList.remove("active");
        } else {
            container.parentElement.parentElement.querySelector('.error-form').classList.remove("active");
        }

        // Check the input radio
        inputRadio.checked = true;

        // Parse active elements to remove active class
        const ACTIVE_ELEMENTS = container.parentElement.querySelectorAll('.active');
        for (let i = 0; i < ACTIVE_ELEMENTS.length; i++) {
            ACTIVE_ELEMENTS[i].classList.remove('active');
        }

        // Then active
        container.classList.add("active");
    }

    static _removeColorActiveItemMenu(navbarStart, navbarBrand) {
        // remove the green color item menu after the 400ms animation
        setTimeout(() => {
            navbarStart.classList.remove("green-is-active");
        }, 400);

        navbarBrand.classList.remove("active-slide");
    }

    static _hidePreviousSlidesDuringTheBackAnimation(index, slides) {
        // to  not see the previous slides during the animation after clicking on the back button
        for (let i = 1; i < index; i++) {
            slides[i].style.display = "none";

            setTimeout(() => {
                slides[i].style.display = "flex";
            }, 500);
        }
    }
}